import {call, put, takeEvery} from 'redux-saga/effects'
import Api from '../services/Api'

function *fetchWheelsExchangePlanning(action) {
  const {type} = action.request;
  try {
    const planning = yield call(() => Api.get('/wheels-exchange/planning', action.request));
    yield put({type: `FETCH_${type}_EXCHANGE_PLANNING.SUCCESS`, planning})
  } catch (error) {
    yield put({type: `FETCH_${type}_EXCHANGE_PLANNING.FAILURE`, error})
  }
}

function *fetchWheelsExchangePlanningSlots(action) {
  const {type} = action.request;
  try {
    const slots = yield call(() => Api.get('/wheels-exchange/slots', action.request));
    yield put({type: `FETCH_${type}_EXCHANGE_SLOTS.SUCCESS`, slots})
  } catch (error) {
    yield put({type: `FETCH_${type}_EXCHANGE_SLOTS.FAILURE`, error})
  }
}

function *fetchSwitchExchangePlanningSlots(action) {
  try {
    const slots = yield call(() => Api.get('/wheels-exchange/slots', action.request));
    yield put({type: 'FETCH_SWITCH_EXCHANGE_SLOTS.SUCCESS', slots})
  } catch (error) {
    yield put({type: 'FETCH_SWITCH_EXCHANGE_SLOTS.FAILURE', error})
  }
}

function *saveWheelsExchangePlanningSlots(action) {
  const {type, day, updatedSlot} = action.request;
  try {
    const slots = yield call(() => Api.put(`/wheels-exchange/slots`, {type, day, ...updatedSlot}));
    yield put({type: `SAVE_${type}_EXCHANGE_SLOTS.SUCCESS`, slots});
    yield put({type: `FETCH_${type}_EXCHANGE_PLANNING.REQUEST`, request: {type, day}});
    yield put({type: `FETCH_${type}_EXCHANGE_SLOTS.REQUEST`, request: {type, day}});

    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: `SHOW_${type}_EXCHANGE_SLOT_ADD_MODAL`, params: {show: false}});
    yield put({type: `SHOW_${type}_EXCHANGE_SLOT_EDIT_MODAL`, params: {show: false}});
  } catch (error) {
    yield put({type: `SAVE_${type}_EXCHANGE_SLOTS.FAILURE`, error});
  }
}

export function* watchFetchWheelsExchangePlanning() {
  yield takeEvery('FETCH_WHEELS_EXCHANGE_PLANNING.REQUEST', fetchWheelsExchangePlanning);
  yield takeEvery('FETCH_TIRES_EXCHANGE_PLANNING.REQUEST', fetchWheelsExchangePlanning);

  yield takeEvery('FETCH_WHEELS_EXCHANGE_SLOTS.REQUEST', fetchWheelsExchangePlanningSlots);
  yield takeEvery('FETCH_TIRES_EXCHANGE_SLOTS.REQUEST', fetchWheelsExchangePlanningSlots);
  yield takeEvery('FETCH_SWITCH_EXCHANGE_SLOTS.REQUEST', fetchSwitchExchangePlanningSlots);

  yield takeEvery('SAVE_WHEELS_EXCHANGE_SLOTS.REQUEST', saveWheelsExchangePlanningSlots);
  yield takeEvery('SAVE_TIRES_EXCHANGE_SLOTS.REQUEST', saveWheelsExchangePlanningSlots);
}



// WEBPACK FOOTER //
// ./src/sagas/wheelsExchangePlanning.js